import React, { Suspense } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
  useParams,
  useRoutes,
} from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import { PcLayout } from "./componments/pc-layout";
import "./App.less";
export { default as cn } from "classnames";

const InviteUser = React.lazy(() => import("@/pages/invite-user/index"));
const InvitePartner = React.lazy(() => import("@/pages/invite-partner/index"));
const InviteRebate1 = React.lazy(() => import("@/pages/invite-rebate/index"));
const InvitePartnerResult = React.lazy(
  () => import("@/pages/invite-partner/result")
);
const InvitePartnerMutiResult = React.lazy(
  () => import("@/pages/invite-partner/invite-rate-setting-result")
);
const InvitePartnerMutiRateSettingResult = React.lazy(
  () => import("@/pages/invite-partner/invite-muti-rate-setting-result")
);
const InviteCurrent = React.lazy(() => import("@/pages/invite-current/index"));
const InviteHistory = React.lazy(() => import("@/pages/invite-history/index"));
const SpotInviteCurrent = React.lazy(
  () => import("@/pages/spot-invite-current/index")
);
const SpotInviteHistory = React.lazy(
  () => import("@/pages/spot-invite-history/index")
);
const InviteCommission = React.lazy(
  () => import("@/pages/invite-commission/index")
);
const InviteGift = React.lazy(() => import("@/pages/invite-gift/index"));
const InviteDashboard = React.lazy(
  () => import("@/pages/invite-dashboard/index")
);
const FundList = React.lazy(() => import("@/pages/fund-list/index"));
const Test = React.lazy(() => import("@/pages/test/index"));
const MyReferral = React.lazy(() => import("@/pages/my-referral/index"));
const InviteChannel = React.lazy(() => import("@/pages/invite-channel/index"));
const InviteAssessment = React.lazy(
  () => import("@/pages/invite-assessment/index")
);

const i18nList = {
  "en-us": "English",
  "zh-cn": "简体中文",
  "zh-hk": "繁體中文",
  "zh-tc": "繁體中文",
  "ru-ru": "Русский",
  "de-de": "Deutsch",
  "fr-fr": "Français",
  "es-es": "Español (España)",
  "es-la": "Español (Latinoamérica)",
  "tr-tr": "Türkçe",
  "vi-vi": "Tiếng Việt",
  "pt-br": "Português (Brasil)",
  "pt-pt": "Português (Portugal)",
  "it-it": "Italiano",
  "nl-nl": "Nederlands",
  "uk-ua": "Українська",
  "hi-in": "हिन्दी",
};

function LangAuth({ children }: { children: JSX.Element }) {
  const { LANG } = useParams();
  const location = useLocation();
  const acceptLangList = Object.keys(i18nList);
  if (LANG && !acceptLangList.includes(LANG)) {
    const browserLang = "en-us";
    window.location.href = `/${browserLang}${
      location.pathname.split(LANG || "")[1] || location.pathname
    }${location.search || ""}`;
    return <></>;
  }
  return children;
}

function App() {
  const routes: RouteObject[] = [
    {
      path: "/",
      element: <Outlet />,
      children: [
        { index: true, element: <Navigate to={`en-us`} replace /> },
        {
          path: "/:LANG",
          element: (
            <LangAuth>
              <Outlet />
            </LangAuth>
          ),
          children: [
            { index: true, element: <Navigate to={`statistics`} replace /> },
            {
              path: "statistics",
              element: (
                <LangAuth>
                  <PcLayout />
                </LangAuth>
              ),
              children: [
                {
                  index: true,
                  element: <Navigate to={`invite-dashboard`} replace />,
                },
                // {path: 'invite-statistics', element: <Suspense fallback={ <>...</> }><InviteStatistics /></Suspense>},
                // {path: 'invite-rebate1', element: <Suspense fallback={ <>...</> }><InviteRebate /></Suspense>},
                // {path: 'earnings-details', element: <Suspense fallback={ <>...</> }><EarningsDetails /></Suspense>},
                // {path: 'invite-earn-details', element: <Suspense fallback={ <>...</> }><InviteEarningsDetails /></Suspense>},

                {
                  path: "invite-statistics",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteDashboard />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-rebate",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteDashboard />
                    </Suspense>
                  ),
                },
                {
                  path: "earnings-details",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteDashboard />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-earn-details",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteDashboard />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-dashboard",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteDashboard />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-partner",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InvitePartner />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-current",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteCurrent />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-history",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteHistory />
                    </Suspense>
                  ),
                },
                {
                  path: "spot-invite-current",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <SpotInviteCurrent />
                    </Suspense>
                  ),
                },
                {
                  path: "spot-invite-history",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <SpotInviteHistory />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-user",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteUser />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-commission",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteCommission />
                    </Suspense>
                  ),
                },
                {
                  path: "invite-gift",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <InviteGift />
                    </Suspense>
                  ),
                },
                {
                  path: "Fund",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <FundList />
                    </Suspense>
                  ),
                },
                {
                  path: "myreferral",
                  element: (
                    <Suspense fallback={<>...</>}>
                      <MyReferral />
                    </Suspense>
                  ),
                },

                { path: "test", element: <Test /> },
              ],
            },
            {
              path: "statistics/invite-partner-result",
              element: (
                <Suspense fallback={<>...</>}>
                  <InvitePartnerResult />
                </Suspense>
              ),
            },
            {
              path: "statistics/invite-rate-setting-result",
              element: (
                <Suspense fallback={<>...</>}>
                  <InvitePartnerMutiResult />
                </Suspense>
              ),
            },
            {
              path: "statistics/invite-muti-rate-setting-result",
              element: (
                <Suspense fallback={<>...</>}>
                  <InvitePartnerMutiRateSettingResult />
                </Suspense>
              ),
            },
            {
              path: "statistics/invite-invite-channel",
              element: (
                <Suspense fallback={<>...</>}>
                  <InviteChannel />
                </Suspense>
              ),
            },
            {
              path: "statistics/invite-assessment",
              element: (
                <Suspense fallback={<>...</>}>
                  <InviteAssessment />
                </Suspense>
              ),
            },
            {
              path: "*",
              element: <Navigate to={`statistics`} replace />,
            },
          ],
        },
        {
          path: "*",
          element: <Navigate to={`statistics`} replace />,
        },
      ],
    },
  ];
  return useRoutes(routes);
}

export default App;
